import { HttpClient,HttpHeaders, HttpBackend} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable  } from 'rxjs';
import { map } from 'rxjs/operators'
import { EnvService } from '../../core/env.service';
import {InvoiceFullDetailsViewModel} from '../model/InvoiceFullDetailsViewModel'
import {InvoiceListViewModel} from '../model/InvoiceListViewModel'
import {InvoiceAttachmentsDTO} from '../model/InvoiceAttachmentsDTO';
import { GlobalService } from '../../commonservices/global.service';

const headers = new HttpHeaders().set('Content-Type','application/json')
@Injectable()
export class WebResService {
    constructor(private _httpClient: HttpClient,public _env: EnvService, private _uploadHttpClient: HttpClient, private _uploadHandler: HttpBackend,private _globalService: GlobalService) {
        this._uploadHttpClient = new HttpClient(_uploadHandler);
    }

    getInvoice(currency:String): Observable<InvoiceListViewModel> {
        return this._httpClient.get<InvoiceListViewModel>(this._env.apiWebResolution +'WebResInvoice/GetWebResInvoice?toCurrency='+currency)
        .pipe(map((res: InvoiceListViewModel) => res));
    }

    getInvoiceByClientName(currency:String,clientName:String,pageNo:number,pageSize:number,reasoCode:string,pieCode:string,clientCarrier:String,sortBy:string,sort:boolean,filter: any): Observable<InvoiceListViewModel> {
        return this._httpClient.post<any>(this._env.apiWebResolution +'WebResInvoice/GetWebResInvoiceByClient?toCurrency='+currency+'&clientName='+clientName
        +'&pageNo='+pageNo+'&pageSize='+pageSize+'&reasoCode='+reasoCode+'&pieCodes='+pieCode+'&clientCarrier='+clientCarrier+'&sortBy='+sortBy+'&sort='+sort,filter)
        .pipe(map((res: any) => res));
    }

    GetWebResInvoiceOnPageChange(currency:String,clientName:String,pageNo:number,pageSize:number,reasoCode:string,pieCode:string,clientCarrier:String,sortBy:string,sort:boolean,filter: any): Observable<InvoiceListViewModel> {
        return this._httpClient.post<any>(this._env.apiWebResolution +'WebResInvoice/GetWebResInvoiceOnPageChange?toCurrency='+currency+'&clientName='+clientName
        +'&pageNo='+pageNo+'&pageSize='+pageSize+'&reasoCode='+reasoCode+'&pieCodes='+pieCode+'&clientCarrier='+clientCarrier+'&sortBy='+sortBy+'&sort='+sort,filter)
        .pipe(map((res: any) => res));
    }

    getInvoiceById(invoiceId:Number): Observable<InvoiceFullDetailsViewModel> {
        return this._httpClient.get<InvoiceFullDetailsViewModel>(this._env.apiWebResolution +'WebResInvoice/GetWebResInvoiceById?invoiceId='+invoiceId)
         .pipe(map((res: InvoiceFullDetailsViewModel) => res));
    }

    getInvoiceByIdPromise(invoiceId): Observable<any> {
        return this._httpClient.get(this._env.apiWebResolution +'WebResInvoice/GetWebResInvoiceById?invoiceId='+invoiceId).pipe(map((event:any) => event));
    }

    uploadFile(inv: String,formData: FormData,token: any) {
        return this._uploadHttpClient.post<FormData>(this._env.apiWebResolution +'WebResInvoice/UploadWebResFile?invoiceIds='+inv,formData, {headers: new HttpHeaders({'ngsw-bypass': 'true',skip:"true"},).set('Authorization', `Bearer ${token}`),reportProgress: true, observe: 'events',})
        .pipe(map((event:any) => event));
    }
    
    approveInvoice(invoiceId: any, comment: string): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json'}) };
        return this._httpClient.put<any>(this._env.apiWebResolution +'WebResInvoice/ApproveWebResInvoice',{invoiceId,comment},httpOptions)
        .pipe(map((res: any) => res));
    }
    rejectedInvoice(invoiceId: any, comment: string): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json'}) };
        return this._httpClient.put<any>(this._env.apiWebResolution +'WebResInvoice/RejectWebResInvoice',{invoiceId,comment},httpOptions)
        .pipe(map((res: any) => res));
    }
    sendCommentToCarrierClient(invoiceId: any, messageToBeDirectedTo: Number, comment: string): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json'}) };
        return this._httpClient.put<any>(this._env.apiWebResolution +'WebResInvoice/SendWebResMessage',{invoiceId,messageToBeDirectedTo,comment},httpOptions)
        .pipe(map((res: any) => res));
    }

    removeFile(inv: String,ffieName: String):Observable<String>{
        return this._httpClient.get<String>(this._env.apiWebResolution +'WebResInvoice/RemoveWebResFile?invoiceId='+ inv +'&fileName='+ffieName)
        .pipe(map((res: any) => res));
    }

    getFileAttachment(invoiceId: any):Observable<Array<InvoiceAttachmentsDTO>>{
        return this._httpClient.get<Array<InvoiceAttachmentsDTO>>(this._env.apiWebResolution +'WebResInvoice/GetWebResFileAttachment?invoiceId='+ invoiceId)
        .pipe(map((res: any) => res));
    }

    getFileAttachments(invoiceIds: any):Observable<Array<InvoiceAttachmentsDTO>>{
        return this._httpClient.get<Array<InvoiceAttachmentsDTO>>(this._env.apiWebResolution +'WebResInvoice/GetWebResFileAttachments?invoiceIds='+ invoiceIds)
        .pipe(map((res: any) => res));
    }

    getWebResAttachment(fileName: string,isa: string,invoiceId: number):Observable<Blob> {
        return this._httpClient.get(this._env.imageArchiveUri +'Document/GetWebResAttachment?fle='+fileName+'&isa='+isa+'&invoiceId='+invoiceId,{ headers: new HttpHeaders({'ngsw-bypass': 'true' ,
            'Content-Type': 'application/json',
          }),
           responseType: 'blob'},);
    }

    getWebResAttachmentOpenPDF(fileName: string,isa: string,invoiceId: number):Observable<Blob> {
        return this._httpClient.get(this._env.imageArchiveUri +'Document/GetWebResAttachmentOpenPDF?fle='+fileName+'&isa='+isa+'&invoiceId='+invoiceId,{ headers: new HttpHeaders({'ngsw-bypass': 'true' ,
            'Content-Type': 'application/json',
          }),
           responseType: 'blob'},);
    }

    getWebResUserType(): Observable<string> {
        return this._httpClient.get<string>(this._env.apiWebResolution +'WebResInvoice/GetWebResUserType')
        .pipe(map((res: any) => res));
    }

    getShipmentInformation(shipmentId:Number): Observable<InvoiceFullDetailsViewModel> {
        return this._httpClient.get<InvoiceFullDetailsViewModel>(this._env.apiWebResolution +'WebResInvoice/GetShipmentInformationDetails?shipmentId='+shipmentId)
         .pipe(map((res: InvoiceFullDetailsViewModel) => res));
    }
    getAllocation(invoiceId: Number){
        return this._httpClient.get<Array<any>>(this._env.apiWebResolution +'WebResInvoice/GetAllocation?invoiceId='+ invoiceId)
        .pipe(map((res: any) => res));
    }

    getWebResTreemapOnClickOthers(currency:String, clientName:String, pageNo:Number): Observable<any> {
        return this._httpClient.get<any>(this._env.apiWebResolution +'WebResInvoice/getWebResTreemapOnClickOthers?toCurrency='+currency+'&clientName='+clientName+'&page='+pageNo)
        .pipe(map((res: any) => res));
    }

    GetWebResExport(currency:String,clientName:String,pageNo:number,pageSize:number,reasoCode:string,pieCode:string,clientCarrier:String,sortBy:string,sort:boolean,commaSepInvs:string,filter: any): Observable<InvoiceListViewModel> {
        return this._httpClient.post<any>(this._env.apiWebResolution +'WebResInvoice/GetWebResExport?toCurrency='+currency+'&clientName='+clientName
        +'&pageNo='+pageNo+'&pageSize='+pageSize+'&reasoCode='+reasoCode+'&pieCodes='+pieCode+'&clientCarrier='+clientCarrier+'&sortBy='+sortBy+'&sort='+sort+'&commaSepInvs='+commaSepInvs,filter)
        .pipe(map((res: any) => res));
    }

    GetWebResSearchInvoiceNo(data: any, page: number, client: string, invoiceShipment: boolean): Observable<any> {
        // var params = this.globalS.serialize(data);
        return this._httpClient.get<any[]>(this._env.apiWebResolution +`WebResInvoice/GetWebResSearchInvoiceNo?input=${data}&page=${page}&client=${client}&invoiceShipment=${invoiceShipment}`);
    }
}